
import React from 'react';
import { useEditor } from '../contexts/EditorContext';
import { Language } from '../types';

interface EditableProductTextProps {
  productId: string;
  field: 'name' | 'description' | 'category' | 'code';
  value: string; // 当前语言的真实值
  lang: Language;
  className?: string;
  multiline?: boolean;
}

export const EditableProductText: React.FC<EditableProductTextProps> = ({ 
  productId, 
  field, 
  value, 
  lang, 
  className = "", 
  multiline = false 
}) => {
  const { isEditMode, updateProduct, products } = useEditor();
  const product = products.find(p => p.id === productId);

  // 获取英文作为兜底
  const englishFallback = product ? (product as any)[field]?.[Language.EN] : "";
  
  // 最终显示的显示逻辑
  const displayValue = (value && String(value).trim() !== "") ? value : (englishFallback || "");

  if (isEditMode) {
    const inputClasses = `bg-green-50 border-2 border-dashed border-green-400 rounded px-2 py-1 w-full text-gray-900 focus:outline-none focus:border-green-600 transition-colors ${className}`;
    
    return (
      <div className="w-full" onClick={(e) => e.stopPropagation()}>
        {multiline ? (
          <textarea 
            value={value || ""}
            onChange={(e) => updateProduct(productId, field, lang, e.target.value)}
            className={inputClasses}
            rows={3}
            placeholder={`[EN]: ${englishFallback}`}
          />
        ) : (
          <input 
            type="text"
            value={value || ""}
            onChange={(e) => updateProduct(productId, field, lang, e.target.value)}
            className={inputClasses}
            placeholder={`[EN]: ${englishFallback}`}
          />
        )}
      </div>
    );
  }

  return <span className={className}>{displayValue}</span>;
};
